import React, { Component } from 'react';
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from '../Navbar/AdminLeftMenu';
import { HOST_URL } from '../Dashboard/api/Api';

class NotificationStatus extends Component {

  constructor() {

    const lStorage =
      JSON.parse(localStorage.getItem("admin")) ||
      JSON.parse(localStorage.getItem("emp")) ||
      JSON.parse(localStorage.getItem("reseller")) ||
      JSON.parse(localStorage.getItem("client"));
    const userId = lStorage.user.userId;
    const name = lStorage.user.name;
    const userToken = lStorage?.token;
    const type = lStorage.user.isAdmin;
    const reseller_type = lStorage?.user?.reseller_type

    super();
    this.state = {
      user_id: userId,
      token: userToken,
      DailyUsageStatus: false,
      LowBalanceStatus: false,
      LowBalanceAmount: '',
      errorMessage: '',
      successMessage: false,
      bgColor: ''
    }
  }


  componentDidMount() {
    this.getUserStatus()
  }

  getUserStatus() {
    fetch(`${HOST_URL}/profile.php?user_id=${this.state.user_id}&method=retrieve&token=${this.state.token}`).then((response) => {
      response.json().then((result) => {
        if (result.success === true) {

          if (result.data[0].is_daily_usage === 1) {
            this.setState({ DailyUsageStatus: true });
          } else {
            this.setState({ DailyUsageStatus: false });
          }

          this.setState({ LowBalanceAmount: result.data[0].low_balance_val });

          if (result.data[0].is_low_balance === 1) {
            this.setState({ LowBalanceStatus: true });
          } else {
            this.setState({ LowBalanceStatus: false });
          }
        }
      })
    })
  }


  updateStatus() {
    let DailyUsagestatus = this.state.DailyUsageStatus ? 1 : 0;
    let LowBalance = this.state.LowBalanceStatus ? 1 : 0;

    // --- POST request for Daily Usage ---
    fetch(`${HOST_URL}/manage_daily_usage_report.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        user_id: this.state.user_id,
        status: DailyUsagestatus,
        token: this.state.token
      })
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          this.setState({
            successMessage: true,
            bgColor: "alert alert-success alert-dismissible",
            errorMessage: result.data,
          });
        } else {
          this.setState({
            successMessage: true,
            bgColor: "alert alert-danger alert-dismissible",
            errorMessage: result.data,
          });
        }
      });

    // --- POST request for Low Balance ---
    fetch(`${HOST_URL}/manage_low_balance_report.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        user_id: this.state.user_id,
        status: LowBalance,
        amount: this.state.LowBalanceAmount,
        token: this.state.token
      })
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          this.setState({
            successMessage: true,
            bgColor: "alert alert-success alert-dismissible",
            errorMessage: result.data,
          });
        } else {
          this.setState({
            successMessage: true,
            bgColor: "alert alert-danger alert-dismissible",
            errorMessage: result.data,
          });
        }
      });
  }



  toggleDailyStatus = () => {
    this.setState({ DailyUsageStatus: !this.state.DailyUsageStatus })
  }

  toggleLowBalance = () => {
    this.setState({ LowBalanceStatus: !this.state.LowBalanceStatus })
  }


  render() {
    return (
      <div className="wrapper">
        <AdminLeftMenu />
        <div className="main">
          <AdminHeader />
          <main className="content">
            <div className="container-fluid p-0">
              <div className="row mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3><strong>Notification </strong> Setup </h3>
                </div>
              </div>
              <div className="row">

                {
                  this.state.successMessage ?
                    <div className={this.state.bgColor} role="alert">
                      <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                      <div className="">
                        {this.state.errorMessage}
                      </div>
                    </div>
                    :
                    null
                }

                <div className="card">
                  <div className="card-body">


                    <div className="notification-list">
                      <p>Get Daily Usage Reports on your email </p>
                      <label className="switch">
                        <input
                          type="checkbox"
                          onChange={this.toggleDailyStatus}
                          checked={this.state.DailyUsageStatus}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                    <hr className="mt-0 mb-2" />
                    <div className="notification-list">
                      <p> Low Balance Alert Email </p>
                      <p>Enter Low Balance Threshold:

                        <input
                          type="text" style={{ width: 200 + 'px', height: 20 + 'px' }}
                          onChange={(event) => this.setState({ LowBalanceAmount: event.target.value })}
                          defaultValue={this.state.LowBalanceAmount}
                          className="form-control"
                        /></p>

                      <label className="switch">
                        <input
                          type="checkbox"
                          onChange={this.toggleLowBalance}
                          checked={this.state.LowBalanceStatus}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>

                    <hr className="mt-0 mb-0" />
                    <div className="text-right d-block">
                      <button onClick={() => this.updateStatus()} className="btn btn-sm mt-4 btn-primary">Update and Save </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </main>
          <AdminFooter />
        </div>
      </div>
    );
  }
}

export default NotificationStatus;